import membersOnlyWarningModalSlice from './slice';

// eslint-disable-next-line import/prefer-default-export
export const { setMembersOnlyWarningModalState } = membersOnlyWarningModalSlice.actions;
